import React from 'react'
import ReactDOM from 'react-dom'
import Root from 'containers/Root.js'

ReactDOM.render(
  <Root />,
  document.getElementById('root')
)
